import * as React from 'react';
import { SVGProps } from 'react';

const FileIconUndefinedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M31.733 0H2.267C1.015 0 0 .895 0 2v36c0 1.105 1.015 2 2.267 2h29.466C32.985 40 34 39.105 34 38V2c0-1.105-1.015-2-2.267-2Z" />
    <path
      d="M20 16.64c0 .56-.027.98-.08 1.26-.053.267-.173.54-.36.82L17.04 21v2H15v-2.5l2.92-2.92c.053-.187.08-.44.08-.76v-.52c0-.413-.12-.733-.36-.96-.24-.227-.607-.34-1.1-.34H13v-2h3.3c2.24 0 3.7 1 3.7 3v.64ZM17 25v2h-2v-2h2Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconUndefinedSizeM;
